var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.902 3.75l-8.268 6.57v10.34H8.14v-4.89c0-1.867 1.686-3.386 3.758-3.386s3.757 1.52 3.757 3.386v4.89h4.506V10.193zm-.009-1.915L24 11.281l-.925 1.185-1.41-1.099v10.798H14.15V15.77c0-1.037-1.01-1.88-2.252-1.88-1.243 0-2.254.843-2.254 1.88v6.395H2.13v-10.65l-1.193.948L0 11.285z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default ForwardRef;